import { RcClasses } from '../../../../foundation';
import { RcTextField } from '../../TextField';
export var RcSelectClasses = RcClasses(['icon'], 'RcSelect');
export var RcSelectInputClasses = RcClasses(['root', 'focused', 'error', 'disabled'], 'RcSelectInput');
export var RcSelectInputWhenPlaceholderClasses = RcClasses(['input'], 'RcSelectInputWhenPlaceholder');
export var RcLineSelectInputClasses = RcClasses(['input'], 'RcLineSelectInput');
export var RcBoxSelectInputClasses = RcClasses(['root', 'focused', 'input', 'error', 'disabled'], 'RcBoxSelectInput');
export var RcSelectInputClassesMap = {
    box: RcBoxSelectInputClasses,
    line: RcLineSelectInputClasses,
};
export var RcBoxSelectInputHeights = {
    medium: 32,
    large: 40,
};
/** inner type, just for type change with TextField */
export var RcSelectTextField = RcTextField;
